import EditIcon from 'assets/icons/edit';
import { IconButton } from '@mui/material';

const EditIconButton = ({ onClick, disabled = false }) => {
	return (
		<IconButton sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px' }} onClick={onClick} disabled={disabled}>
			<EditIcon color="#00b050" width="20px" height="20px" />
		</IconButton>
	);
};

export default EditIconButton;
